<template>
  <div id="search" class="relativeItem">
    <!--搜索框-->
    <div class="seshell">
      <div class="s conditionTop o08rem relativeItem">
        <input type="text" placeholder="请输入靓号或昵称" class="radius3" v-model="word">
        <span class="absoluteItem centerY" v-if="!showResult" @touchstart="ptsearch">搜索</span>
        <span class="cancel absoluteItem centerY" v-else @click="closeResult">取消</span>
      </div>
    </div>
    <!--搜索条件-->
    <div class="condition" v-if="!showResult">
      <!--性别-->
      <ul class="gender o08rem whiteB overHidden">
        <li>
          <p class="title">性别</p>
          <p class="sli">
            <span
              class="radius3"
              :class="{active:gender.choose == n.type}"
              v-for="(n, index) in gender.sj"
              :key="index"
              @click="gender.choose = n.type"
            >{{ n.text }}</span>
          </p>
        </li>
        <li>
          <p class="title">城市</p>
          <p class="sli apostrophe relativeItem">
            <span
              class="radius3"
              :class="{active:city.id == index}"
              v-for="(n, index) in city.c"
              :key="index"
              @click="city.id = index"
            >{{ n }}</span>
            <span class="arrow absoluteItem centerY" @click="showct = true">更多</span>
          </p>
        </li>
        <li>
          <p class="title">最近直播</p>
          <p class="sli">
            <span
              class="radius3"
              :class="{active:times.choose == n.value}"
              v-for="(n, index) in times.sj"
              :key="index"
              @click="times.choose = n.value"
            >{{ n.text }}</span>
          </p>
        </li>
      </ul>

      <!--贵族特权区域-->
      <div class="tq o08rem whiteB overHidden relativeItem">
        <a class="allA" @click="notGuizu" v-if="info.guizhu == '0'"></a>
        <p class="tqtitle">
          <img src="../../assets/search (2).png">
          <span>贵族专享高级筛选</span>
        </p>
        <div>
          <p class="title">年龄</p>
          <p class="ages sli flex-box relativeItem">
            <span>{{ age.min }} - {{ age.max }}</span>
            <hk class="hk absoluteItem centerY" :value-fun="see" :min="0" :max="100"></hk>
          </p>
        </div>
        <div>
          <p class="title">星座</p>
          <p class="sli relativeItem">
            <span
              class="radius3"
              :class="{active:signeAc[0].text == n.text}"
              v-for="(n, index) in pickData.data1"
              :key="index"
              @click="signeAc[0].text = n.text,signeAc[0].value = n.value"
              v-show="index < 4"
            >{{ n.text }}</span>
            <span class="arrow absoluteItem centerY" @click="toShow">更多</span>
          </p>
        </div>
      </div>
      <!--按钮区域-->
      <div class="anshell whiteB">
        <div class="an radius3" @click="jzsearch">精准搜索</div>
      </div>
    </div>

    <!--搜索结果-->
    <div class="result" v-else>
      <plist :list="list" whatP="own"></plist>

      <!--空白-->
      <blank message="暂无信息" v-if="blank"></blank>
      <!--空白文本组件-->
      <blanktext v-if="blankText"></blanktext>
    </div>

    <!--星座选择框-->
    <div class="ms" v-show="show">
      <vue-pickers
        :show="show"
        :columns="columns"
        :defaultData="signeAc"
        :selectData="pickData"
        @cancel="close"
        @confirm="confirmFn"
      ></vue-pickers>
    </div>

    <!--城市选择-->
    <transition name="fade">
      <cities v-show="showct" @closect="closeCityTc"></cities>
    </transition>
  </div>
</template>

<script>
import vuePickers from "vue-pickers";
import hk from "./hk";
import cities from "./cities";
import plist from "../me/plist";
import blank from "../me/blank";
import blanktext from "../me/blankText";

export default {
  name: "search",
  components: {
    hk,
    vuePickers,
    cities,
    plist,
    blank,
    blanktext
  },
  props: [],
  data() {
    return {
      scroll: true, //当前页面是否允许加载等多
      searchAll: false, //false普通搜索，true精准搜索
      showResult: false, //是否显示搜索结果
      word: "", //普通搜索的条件
      page: 1,
      ismore: true,
      blank: false,
      blankText: false,
      list: [],
      info: [], //个人信息
      age: {
        min: 0,
        max: 100,
        total: "0_100"
      },
      gender: {
        sj: [
          {
            text: "不限",
            type: "2"
          },
          {
            text: "女",
            type: "0"
          },
          {
            text: "男",
            type: "1"
          }
        ],
        choose: "2" //0女 1男 2不限
      },
      showct: false,
      city: {
        c: ["全国", "重庆", "上海", "杭州"],
        id: 0
      },
      times: {
        sj: [
          {
            text: "不限",
            value: 0
          },
          {
            text: "15分钟",
            value: 15 * 60
          },
          {
            text: "1小时",
            value: 60 * 60
          },
          {
            text: "1天",
            value: 24 * 60
          },
          {
            text: "3天",
            value: 3 * 24 * 60
          }
        ],
        choose: 0 //0不限 1 15分钟 2 1小时 3 1天 4 3天
      },
      time: "0", //0不限 1 15分钟 2 1小时 3 1天 4 3天
      signe: "不限", //星座
      show: false,
      columns: 1,
      signeAc: [
        {
          text: "不限",
          value: ""
        }
      ],
      pickData: {
        // 第一列的数据结构
        data1: [
          {
            text: "不限",
            value: ""
          },
          {
            text: "白羊座",
            value: "1"
          },
          {
            text: "金牛座",
            value: "2"
          },
          {
            text: "双子座",
            value: "3"
          },

          {
            text: "巨蟹座",
            value: "4"
          },
          {
            text: "狮子座",
            value: "5"
          },
          {
            text: "处女座",
            value: "6"
          },

          {
            text: "天秤座",
            value: "7"
          },
          {
            text: "天蝎座",
            value: "8"
          },
          {
            text: "射手座",
            value: "9"
          },

          {
            text: "魔羯座",
            value: "10"
          },
          {
            text: "水瓶座",
            value: "11"
          },
          {
            text: "双鱼座",
            value: "12"
          }
        ]
      }
    };
  },
  methods: {
    //星座选择器
    close() {
      this.show = false;
    },
    confirmFn(val) {
      this.show = false;
      if (val.select1.text == "不限") {
        //让无限保持在首位
        this.signeAc = [val.select1];
      } else {
        //替换第二个
        for (let i = 0; i < this.pickData.data1.length; i++) {
          if (this.pickData.data1[i].text == val.select1.text) {
            this.pickData.data1.splice(i, 1);
          }
        }
        this.pickData.data1.splice(1, 0, val.select1);
        this.signeAc = [val.select1];
      }
    },
    toShow() {
      this.show = true;
    },
    //年龄滑动条
    see(min, max) {
      this.age.min = min;
      this.age.max = max;
      this.age.total = min + "_" + max;
    },
    /**设置搜索框的高度 */
    setSheight() {
      let c = this.$tool.getByC("s")[0];
      let cb = this.$tool.getByC("seshell")[0];
      cb.style.height = c.clientHeight + "px";
    },
    /**关闭城市选择器 */
    closeCityTc(text) {
      //替换城市数组第二个
      this.city.c.splice(1, 1);
      this.city.c.splice(1, 0, text);
      this.city.id = 1;
      this.showct = false;
    },
    /**提示用户不是贵族 */
    notGuizu() {
      this.$tool.tip("请开通贵族再使用");
    },
    //获取个人信息
    getInfo() {
      let _this = this;
      this.$jsonp(this.$apis("me"), {}, res => {
        _this.info = res.data.data.result;
      });
    },
    /**关闭搜索结果 */
    closeResult() {
      this.word = "";
      this.page = 1;
      this.ismore = true;
      this.blank = false;
      this.blanktext = false;
      this.showResult = false;
      this.list = [];
    },
    /**搜索按钮触发 */
    ptsearch() {
      if (this.word != "") {
        this.$tool.showLoading();
        this.searchAll = false;
        this.showResult = true;
        this.getList();
      }
    },
    jzsearch() {
      this.$tool.showLoading();
      this.searchAll = true;
      this.showResult = true;
      this.getList();
    },
    /**下拉加载更多 */
    getMore() {
      var _this = this;
      window.onscroll = function() {
        if (!this.scroll) {
          return;
        }
        var fall =
          _this.$tool.getScrollHeight() -
          (_this.$tool.getScrollTop() + _this.$tool.getWindowHeight());
        var is = fall <= 20;
        if (is && _this.ismore) {
          _this.page++;
          _this.getList();
        }
      };
    },
    /**普通搜索 */
    getList() {
      if (!this.showResult) {
        this.page = 1;
        return;
      }
      this.ismore = false;
      let data = {
        page: this.page
      };

      let _this = this;
      if (this.searchAll) {
        //精准搜索
        data.word = this.word;
        data.sex = this.gender.choose; //性别
        data.city_id = this.city.c[this.city.id]; //城市
        data.xingzuo = this.signeAc[0].value; //星座
        data.age_type = this.age.total; //年龄
        data.time_type = this.times.choose; //直播时间段
        this.$jsonp(this.$apis("searchall", "app"), data, res => {
          if (res.data.data.status == 200) {
            let ls = res.data.data.list;
            _this.isblank(ls);
          } else {
            _this.showResult = false;
            _this.$tool.tip(res.data.data.msg)
          }
          _this.$tool.hiddenLoading();
        });
      } else {
        //普通搜索
        data.word = this.word;
        this.$jsonp(this.$apis("search", "app"), data, res => {
          let ls = res.data.data.list;
          _this.isblank(ls);
          _this.$tool.hiddenLoading();
        });
      }
    },
    //判断是否有搜索结果
    isblank(ls) {
      if (ls.length > 0) {
        for (let i = 0; i < ls.length; i++) {
          ls[i].showtitle = "靓号" + ls[i].usernumber;
          ls[i].bkcolor = this.$tool.getBlankColor();
          this.list.push(ls[i]);
        }
        this.ismore = true;
        if (ls.length == 15) {
          this.ismore = true;
        } else {
          this.ismore = false;
          this.blankText = true;
        }
      } else {
        this.ismore = false;
        if (this.page == 1) {
          this.blank = true;
        } else {
          this.blankText = true;
        }
      }
    }
  },
  mounted: function() {
    this.$emit("showOhidden", false, 3);
    this.$tool.setTitle("搜索");
    this.setSheight();
    this.getInfo();
    //开启下拉加载更多
    this.getMore();
  },
  watch: {},
  beforeDestroy() {
    this.scroll = false;
  }
};
</script>















<style scoped>
/*搜索框*/
.s {
  width: 100%;
  padding: 0.4rem 0.8rem;
  background: #f4f4f4 !important;
}
.s * {
  vertical-align: middle;
}
.s input {
  width: 73%;
  margin-right: 3%;
  padding: 0.45rem 0;
  padding-left: 2.4rem;
  font-size: 15px;
  background: url("../../assets/search.png") no-repeat 0.8rem center #fff;
  background-size: 1.3rem;
}
.s span {
  right: .8rem;
  font-size: 15px;
  color: #c471f5;
}
.s .cancel {
  color: #333;
}

/*选择中心*/
.title {
  font-size: 13px;
  color: #999;
  margin: 0.7rem 0;
  margin-top: 1rem;
}
.sli span {
  display: inline-block;
  padding: 0.13rem 0.8rem;
  border: 1px solid #ccc;
  font-size: 13px;
  color: #ccc;
  margin-right: 0.5rem;
}
.sli span:last-child {
  margin: 0;
}
.sli .active {
  border: 1px solid #c471f5;
  background: rgba(196, 113, 245, 0.2);
  color: #c471f5;
}
.gender li {
  margin-bottom: 0.8rem;
}
.gender {
  border-bottom: 1px solid #f4f4f4;
}

/*特权区域*/
.tqtitle * {
  vertical-align: middle;
}
.tqtitle img {
  width: 1.2rem;
  margin-right: 0.3rem;
}
.tqtitle span {
  font-size: 13px;
}
.tqtitle {
  margin-top: 0.7rem;
}
.ages {
  justify-content: flex-start;
}
.ages > span {
  border: 0;
  color: #c471f5;
  padding: 0;
}
.hk {
  width: 75%;
  right: 0.8rem;
}
.arrow {
  border: 0 !important;
  padding: 0 !important;
  padding-right: 2rem !important;
  right: -0.8rem;
  color: #999 !important;
}
.anshell {
  padding: 2rem 0;
}
.an {
  width: 50%;
  font-size: 15px;
  color: #fff;
  background: -webkit-linear-gradient(left, #fa71cd, #c471f5);
  background: linear-gradient(to right, #fa71cd, #c471f5);
  padding: 0.7rem 0;
  text-align: center;
  margin: 0 auto;
}
.allA {
  z-index: 2;
}
/*选择城市进场与退出*/
.fade-enter-active,
.fade-leave-active {
  transition: transform 0.5s;
}
.fade-enter,
.fade-leave-to {
  transform: translateX(100%);
}
</style>

<style>
.ms {
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.3);
  z-index: 4;
}
.area_btn {
  color: #c471f5 !important;
  font-size: 15px !important;
}
.area_btn_box {
  background-color: #fff !important;
}
.area_roll {
  background-color: #fff !important;
  -webkit-mask: -webkit-linear-gradient(
    top,
    #c471f5 50%,
    rgba(36, 142, 36, 0.9)
  ) !important;
}
.area_roll_mask {
  -webkit-mask: -webkit-linear-gradient(
    bottom,
    #c471f5 50%,
    rgba(36, 142, 36, 0.9)
  ) !important;
}
</style>
